// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  list-style: none;
}

/* .example-2 {
  display: flex;
  justify-content: center;
  align-items: center;
} */
.example-2 .icon-content {
  margin: 0 10px;
  position: relative;
}
.example-2 .icon-content .tooltip {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  padding: 6px 10px;
  border-radius: 5px;
  opacity: 0;
  visibility: hidden;
  font-size: 14px;
  transition: all 0.3s ease;
}
.example-2 .icon-content:hover .tooltip {
  opacity: 1;
  visibility: visible;
  top: -50px;
}
.example-2 .icon-content a {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #4d4d4d;
  background-color: #fff;
  transition: all 0.3s ease-in-out;
}
.example-2 .icon-content a:hover {
  box-shadow: 3px 2px 45px 0px rgb(0 0 0 / 12%);
}
.example-2 .icon-content a svg {
  position: relative;
  z-index: 1;
  width: 30px;
  height: 30px;
}
.example-2 .icon-content a:hover {
  color: white;
}
.example-2 .icon-content a .filled {
  position: absolute;
  top: auto;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #000;
  transition: all 0.3s ease-in-out;
}
.example-2 .icon-content a:hover .filled {
  height: 100%;
}

.example-2 .icon-content a[data-social="linkedin"] .filled,
.example-2 .icon-content a[data-social="linkedin"] ~ .tooltip {
  background-color: #0274b3;
}

.example-2 .icon-content a[data-social="github"] .filled,
.example-2 .icon-content a[data-social="github"] ~ .tooltip {
  background-color: #24262a;
}
.example-2 .icon-content a[data-social="instagram"] .filled,
.example-2 .icon-content a[data-social="instagram"] ~ .tooltip {
  background: linear-gradient(
    45deg,
    #405de6,
    #5b51db,
    #b33ab4,
    #c135b4,
    #e1306c,
    #fd1f1f
  );
}
.example-2 .icon-content a[data-social="email"] .filled,
.example-2 .icon-content a[data-social="email"] ~ .tooltip {
  /* background-color: #ff0000; */
  background: linear-gradient(120deg, #e1261c, #c01910);
}
`, "",{"version":3,"sources":["webpack://./src/asset/css/Links.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;;;;GAIG;AACH;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,OAAO;EACP,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE;;;;;;;;GAQC;AACH;AACA;;EAEE,+BAA+B;EAC/B,qDAAqD;AACvD","sourcesContent":["ul {\n  list-style: none;\n}\n\n/* .example-2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n} */\n.example-2 .icon-content {\n  margin: 0 10px;\n  position: relative;\n}\n.example-2 .icon-content .tooltip {\n  position: absolute;\n  top: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 5px;\n  opacity: 0;\n  visibility: hidden;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n.example-2 .icon-content:hover .tooltip {\n  opacity: 1;\n  visibility: visible;\n  top: -50px;\n}\n.example-2 .icon-content a {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  color: #4d4d4d;\n  background-color: #fff;\n  transition: all 0.3s ease-in-out;\n}\n.example-2 .icon-content a:hover {\n  box-shadow: 3px 2px 45px 0px rgb(0 0 0 / 12%);\n}\n.example-2 .icon-content a svg {\n  position: relative;\n  z-index: 1;\n  width: 30px;\n  height: 30px;\n}\n.example-2 .icon-content a:hover {\n  color: white;\n}\n.example-2 .icon-content a .filled {\n  position: absolute;\n  top: auto;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 0;\n  background-color: #000;\n  transition: all 0.3s ease-in-out;\n}\n.example-2 .icon-content a:hover .filled {\n  height: 100%;\n}\n\n.example-2 .icon-content a[data-social=\"linkedin\"] .filled,\n.example-2 .icon-content a[data-social=\"linkedin\"] ~ .tooltip {\n  background-color: #0274b3;\n}\n\n.example-2 .icon-content a[data-social=\"github\"] .filled,\n.example-2 .icon-content a[data-social=\"github\"] ~ .tooltip {\n  background-color: #24262a;\n}\n.example-2 .icon-content a[data-social=\"instagram\"] .filled,\n.example-2 .icon-content a[data-social=\"instagram\"] ~ .tooltip {\n  background: linear-gradient(\n    45deg,\n    #405de6,\n    #5b51db,\n    #b33ab4,\n    #c135b4,\n    #e1306c,\n    #fd1f1f\n  );\n}\n.example-2 .icon-content a[data-social=\"email\"] .filled,\n.example-2 .icon-content a[data-social=\"email\"] ~ .tooltip {\n  /* background-color: #ff0000; */\n  background: linear-gradient(120deg, #e1261c, #c01910);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
